<template>
<div class="col-12" v-if="flowsupplierattributes.length">
 <hr>
<h4 class="text-primary">{{$store.state.languages.lang_phrases.iliskili_ozel_nitelikler}}</h4>
<!-- ungrouped attributes -->
<template v-for="attribute in flowsupplierattributes">
<!-- if supplierattribute appended-->
  <template v-if="attribute.customattribute.supplierattributes.length">
    
  
  <template v-if="attribute.customattribute.type=='string'">
      <ClickEditInputText  :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutetextval" :valkey="attribute.customattribute.id" :read_only="true" />
    
  </template>

  <template v-if="attribute.customattribute.type=='number'">
    <ClickEditNumber   :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id" :read_only="true" />
  </template>

  <template v-if="attribute.customattribute.type=='boolean'">
    <ClickEditSwitch    :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id" :read_only="true" />
  </template>

  <template v-if="attribute.customattribute.type=='categorised'">
    <ClickEditCategory   :allcategories="attribute.customattribute.categories" :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id" :read_only="true" />
  </template>

  <template v-if="attribute.customattribute.type=='cascadecategorised'">
    <ClickEditCascadeCategory   :allcategories="attribute.customattribute.categories" :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id"  :read_only="true"/>
  </template>

  <template v-if="attribute.customattribute.type=='select'">
    <ClickEditSelect    :title="getTheTranslation(attribute.customattribute,'translation')" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id"   :options="attribute.customattribute.options"   :color_selector="true" :read_only="true" />
    
  </template>

</template>
<!-- if supplierattribute appended-->
</template>

<!-- ungrouped attributes -->

</div>
</template>

<script>
export default {

  name: 'SupplierProjectFlowSummaryForAttributes',
  props:["flowsupplierattributes"],
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>